import { Stack, Typography } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import LanguageIcon from '@mui/icons-material/Language'
import PhoneIcon from '@mui/icons-material/Phone'
import PersonIcon from '@mui/icons-material/Person'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'

export function ReadonlyCareManagementDisplay (props: { orgName: string | null, userName: string | null, phone: string | null, email: string | null, website: string | null }): JSX.Element {
  return <>
    <Stack direction='column' spacing={1}>
      <Stack direction='row' spacing={1}>
        <AccountBalanceIcon />
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {props.orgName}
        </Typography>
      </Stack>
      {props.userName != null &&
        <Stack direction='row' spacing={1}>
          <PersonIcon />
          <Typography variant='body1' data-testid="caseloadUser" sx={{ overflowWrap: 'break-word' }}>
            {props.userName}
          </Typography>
        </Stack>
                    }
      {props.phone != null && props.phone !== '' &&
        <Stack direction='row' spacing={1}>
          <PhoneIcon />
          <Typography variant='body1' data-testid="caseloadPhone" sx={{ overflowWrap: 'break-word' }}>
            {props.phone}
          </Typography>
        </Stack>}
      {props.email != null && props.email !== '' &&
        <Stack direction='row' spacing={1}>
          <EmailIcon />
          <Typography variant='body1' data-testid="caseloadEmail" sx={{ overflowWrap: 'anywhere' }}>
            <a href={`mailto:${props.email}`}>{props.email}</a>
          </Typography>
        </Stack>}
      {props.website != null && props.website !== '' &&
        <Stack direction='row' spacing={1}>
          <LanguageIcon />
          <Typography variant='body1' data-testid="caseloadEmail" sx={{ overflowWrap: 'anywhere' }}>
            <a target='_blank' rel='external' href={`http://${props.website}`}>
              {props.website}
            </a>
          </Typography>
        </Stack>
    }
    </Stack>
  </>
}
